import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { PageLoader } from "./layout/PageLoader";
import { theme } from "./theme";

import { WalkthroughProvider } from "@/app/layout/WalkthroughProvider";
import { queryConfig } from "@/lib/react-query";
import { AuthLoader } from "@/services/auth";

import type { FC, PropsWithChildren } from "react";

export type AppProviderProps = PropsWithChildren;

export const AppProvider: FC<AppProviderProps> = ({ children }) => {
  const [queryClient] = useState(() => new QueryClient({ defaultOptions: queryConfig }));

  return (
    <MantineProvider theme={theme}>
      <Suspense fallback={<PageLoader />}>
        <ErrorBoundary FallbackComponent={() => <>TODO</>}>
          <QueryClientProvider client={queryClient}>
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
            <Notifications position="bottom-left" maw={400} />
            <AuthLoader renderLoading={() => <PageLoader />}>
              <WalkthroughProvider>{children}</WalkthroughProvider>
            </AuthLoader>
          </QueryClientProvider>
        </ErrorBoundary>
      </Suspense>
    </MantineProvider>
  );
};
